export default "__VITE_ASSET__b61e5163__"